import { engineComponent, StringUtils, Utils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { BetManager } from "../../Managers/BetManager";
import { AppContext } from "../../../Common/AppContext";
import { HtmlController } from "../HtmlController";
import { BaseActions } from "../../Channels/Common/Actions/BaseActions";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlBetSelectorContainerElement extends HtmlContainerElement {
    private _popup: HTMLDivElement;
    private _values: Array<HTMLDivElement>;
    private _height: string;

    protected block: boolean;
    protected timeout: number;

    constructor() {
        super();

        BetManager.CoinCountContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        this._popup = <HTMLDivElement>document.createElement("div");
        this._popup.classList.add("display");
        this._popup.classList.add("popupBig");

        if (this.instance != null) {
            this.instance.appendChild(this._popup);
        }

        this.block = true;
        this.createTimeout();
    }

    addValues(): void {
        if (
            AppContext.gameConfiguration.UseCoins &&
            BetManager.Coins != null &&
            BetManager.CoinSize != null &&
            this._popup != null
        ) {
            this._values = [];
            this._popup.innerHTML = "";
            let i: number = 0;
            for (let key in BetManager.Coins) {
                if (BetManager.CoinSize === parseFloat(key)) {
                    for (let j: number = 0; j < BetManager.Coins[key].length; j++) {
                        BetManager.Coins[key].sort(BetManager.sortNumber);
                        BetManager.Coins[key].reverse();

                        let popupItem: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        popupItem.classList.add("popupItem");
                        popupItem.onclick = this.onValueClick.bind(this);
                        popupItem.setAttribute("CoinCount", BetManager.Coins[key][j].toString());
                        if (BetManager.CoinCount != null && BetManager.CoinCount == BetManager.Coins[key][j]) {
                            popupItem.classList.add("_active");
                        }
                        let popupItemValue: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        popupItemValue.classList.add("popupValue");
                        popupItemValue.innerText = BetManager.Coins[key][j].toString();

                        popupItem.appendChild(popupItemValue);
                        this._values.push(popupItem);
                        this._popup.appendChild(popupItem);
                        i++;
                    }
                }
            }

            this._height = 60 * i + 48 + "px";
        }
    }

    private onValueClick(e: any): void {
        if (this.block) {
            return;
        }

        this.setTimeout();
        if (
            e != null &&
            e.currentTarget != null &&
            e.currentTarget.hasAttribute("CoinCount") &&
            BetManager.CoinCount != null
        ) {
            let coinCount: number = parseFloat(e.currentTarget.getAttribute("CoinCount"));
            if (coinCount === BetManager.CoinCount) {
                this.disable();
            } else {
                if (this._values != null) {
                    for (let i: number = 0; i < this._values.length; i++) {
                        if (this._values[i].hasAttribute("CoinCount")) {
                            if (parseFloat(this._values[i].getAttribute("CoinCount")) === coinCount) {
                                this._values[i].classList.add("_active");
                            } else {
                                this._values[i].classList.remove("_active");
                            }
                        }
                    }
                    HtmlController.dispatchAction(BaseActions.ActionCoinCountSelectValue + coinCount);
                    this.disable();
                }
            }
        }
    }

    changeValue(): void {
        if (this._values != null) {
            for (let i: number = 0; i < this._values.length; i++) {
                if (this._values[i].hasAttribute("CoinCount")) {
                    if (parseFloat(this._values[i].getAttribute("CoinCount")) === BetManager.CoinCount) {
                        this._values[i].classList.add("_active");
                    } else {
                        this._values[i].classList.remove("_active");
                    }
                }
            }
        }
    }

    toggle(): void {
        if (this._values != null && this._values.length <= 1) {
            return;
        }

        if (this.instance != null) {
            if (this.instance.classList.contains("_disabled")) {
                this.block = false;
                this.setTimeout();
                if (this._height != null) {
                    this.instance.style.height = this._height;
                }
                this.instance.classList.remove("_disabled");
            } else {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    disable(): void {
        if (this.instance != null) {
            if (!this.instance.classList.contains("_disabled")) {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    protected createTimeout(): void {
        this.timeout = null;
    }

    protected setTimeout(): void {
        this.clearTimeOut();

        const duration = AppContext.gameConfiguration.SelectorRolloutDuration;

        if (duration > 0) {
            this.timeout = setTimeout((): void => {
                this.disable();
            }, duration * 1000);
        }
    }

    protected clearTimeOut(): void {
        if (!Utils.isNullOrUndefined(this.timeout)) {
            clearTimeout(this.timeout);

            this.timeout = null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlBetSelectorContainerElement.ts
 **/